/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Reassign_Notice_TitleInputs */

const en_ticket_reassign_notice_title = /** @type {(inputs: Ticket_Reassign_Notice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warning!`)
};

const ja_ticket_reassign_notice_title = /** @type {(inputs: Ticket_Reassign_Notice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ご注意`)
};

const fr_ticket_reassign_notice_title = /** @type {(inputs: Ticket_Reassign_Notice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attention !`)
};

const de_ticket_reassign_notice_title = /** @type {(inputs: Ticket_Reassign_Notice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achtung!`)
};

/**
* | output |
* | --- |
* | "Warning!" |
*
* @param {Ticket_Reassign_Notice_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_reassign_notice_title = /** @type {((inputs?: Ticket_Reassign_Notice_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Reassign_Notice_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_reassign_notice_title(inputs)
	if (locale === "ja") return ja_ticket_reassign_notice_title(inputs)
	if (locale === "fr") return fr_ticket_reassign_notice_title(inputs)
	return de_ticket_reassign_notice_title(inputs)
});